/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createRotateOrganizationApiKeyResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type RotateOrganizationApiKeyResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/api-keys/{keyId}/rotate
 */
export interface RotateRequestBuilder extends BaseRequestBuilder<RotateRequestBuilder> {
    /**
     * Replaces the key's value while keeping its identifier and access. The previous value stops working immediately, so distribute the new one before rotating. The replacement is returned once and cannot be retrieved again.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RotateOrganizationApiKeyResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<RotateOrganizationApiKeyResponse | undefined>;
    /**
     * Replaces the key's value while keeping its identifier and access. The previous value stops working immediately, so distribute the new one before rotating. The replacement is returned once and cannot be retrieved again.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RotateRequestBuilderUriTemplate = "{+baseurl}/api/organizations/api-keys/{keyId}/rotate";
/**
 * Metadata for all the requests in the request builder.
 */
export const RotateRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: RotateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRotateOrganizationApiKeyResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
